<template>
  <div class="edit_container" style="min-height: 220px;">
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
      @change="onEditorChange($event)">
    </quill-editor>
  </div>
</template>

<script>
    export default {
        name: "argeementEdit",
        props: ["parentContent"],
        data() {
            return {
                content: `<br/><br/><br/><br/><br/>`,
                editorOption: {}
            }
        },
        created() {
            this.content = this.parentContent;
        },
        methods: {
            show(content) {
            },
            onEditorReady(editor) {
                // 准备编辑器
            },
            onEditorBlur() {
                // 失去焦点事件
            },
            onEditorFocus() {
                // 获得焦点事件
            },
            onEditorChange(event) {
                // 内容改变事件
                this.$emit("listenToChildEvent", this.content)
            },
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        },
        watch: {
            parentContent(newVal, oldVal) {
                this.content = newVal;
            }
        }
    }
</script>

<style scoped>
  .quill-editor{
    /*min-height:120px;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/plugins/edit/argeementEdit.vue